<template>
  <div>
    <table class="table table--first-medium">
      <tr>
        <td>
          <strong>{{ $t('pages.message.labels.sender') }}</strong>
        </td>
        <td>{{ message.sender }}</td>
      </tr>
      <tr>
        <td>
          <strong>{{ $t('pages.message.labels.subject') }}:</strong>
        </td>
        <td>{{ message.subject }}</td>
      </tr>
      <tr>
        <td>
          <strong>{{ $t('pages.message.labels.messageDate') }}</strong>
        </td>
        <td>{{ $formatDate(message.messageDate, 'yyyy-MM-dd HH:mm') }}</td>
      </tr>
      <tr>
        <td>
          <strong>{{ $t('pages.message.labels.termDate') }}</strong>
        </td>
        <td>
          <template v-if="message.termDate">
            <i class="glyphicon glyphicon-calendar"></i> {{ message.termDate }}
          </template>
        </td>
      </tr>
      <tr>
        <td>
          <strong>{{ $t('pages.message.labels.attachedFiles') }}</strong>
        </td>
        <td>
          <div v-for="file in message.attachedFile" :key="file.id">
            <i class="glyphicon glyphicon-file"></i
            ><a href="#" @click.prevent="$emit('click:file', file)">{{ file.filename }}</a>
          </div>
        </td>
      </tr>
    </table>
    <div v-html="message.messageBody" class="c-message-content" style="white-space: pre-wrap;" />
  </div>
</template>

<script>
export default {
  name: 'MessageContent',

  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped></style>
